module.exports = __webpack_public_path__ + "static/mixcloud-btn-bba96088ddcc3359686f74b210bb3e11.jpg";